import { render, staticRenderFns } from "./CarbonOptions.vue?vue&type=template&id=1d40ce5a&scoped=true"
import script from "./CarbonOptions.vue?vue&type=script&lang=js"
export * from "./CarbonOptions.vue?vue&type=script&lang=js"
import style0 from "./CarbonOptions.vue?vue&type=style&index=0&id=1d40ce5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40ce5a",
  null
  
)

export default component.exports